import React, { FC } from "react";
import Helmet from "react-helmet";
import { useDeviceOptionsStore } from "../../storez/DeviceOptionsStore";

type PageTitleProps = {
  title?: string;
};
const PageTitle: FC<PageTitleProps> = ({ title }) => {
  const deviceOptions = useDeviceOptionsStore((state) => state.options);

  // Show Smoothwall favicon only if device options are available and company is "smoothwall"
  const isSmoothwallBranding = deviceOptions?.customer_internal_company?.toLowerCase() === "smoothwall";

  return (
    <Helmet>
      <title>{title}</title>
      <link rel="icon" href={`/static/images/${isSmoothwallBranding ? "smoothwallfavicon-16x16.png" : "favicon.svg"}`} />
    </Helmet>
  );
};

export default PageTitle;
